<div class="auth-modal-container login">
  <form novalidate
        (ngSubmit)="login()"
        [formGroup]="loginForm"
        class="form-container"
  >
    <div class="logo-img"></div>
    <div class="form-header">
      Sign in
    </div>
    <div class="form-description login bordered">
      Streamline the way your pharmacy handles controlled substances.
    </div>
    <app-input [type]="'email'"
               [autofocus]="true"
               [label]="'Email'"
               formControlName="email"
               (keyupEnter)="focusInput('passwordInput')"
               [tabInd]="1"
               #emailInput
    ></app-input>
    <div class="password-input">
      <app-input [type]="'password'"
                 [label]="'Password'"
                 formControlName="password"
                 #passwordInput
                 (keyupEnter)="login()"
                 (keydownTab)="submitBtn.focus()"
                 [tabInd]="2"
      ></app-input>
      <a #forgotPasswordRef routerLink="./../reset-password" class="forgot-password">
        Forgot password?
      </a>
    </div>

    <div class="error-message" *ngIf="loginError">{{loginError}}</div>

    <app-button class="submit-btn"
                customClasses="w-full"
                [disabled]="(loading$ | async) || loginForm.invalid"
                [text]="'Sign in'"
                type="submit"
                [loading]="loading$ | async"
                #submitBtn
                (keydown.tab)="forgotPasswordRef.focus()"
    ></app-button>
    <div class="new-user">
      New user?
      <a #createAccountRef class="create-acc-ref" routerLink="/auth/sign-up">
        Create an account
      </a>
    </div>
  </form>

  <div class="label-container">
    <div class="label-header login">
      Love <br>
      managing <br>
      your <br>
      controlled substance inventory.
    </div>
  </div>

</div>
